import Vue from "vue";
import {
  Container,
  Main,
  Form,
  FormItem,
  Input,
  Row,
  Col,
  Card,
  Button,
  Image,
  MessageBox,
  Link,
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(Container);
Vue.use(Main);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(Button);
Vue.use(Image);
Vue.use(Link);

Vue.prototype.$alert = MessageBox.alert;
